<hq-side-bar (expandedChange)='expanded=$event'>
    <hq-menu-item label='Campagnes' icon='fa fa-bullhorn' routerLink="/campagnes">
    </hq-menu-item>
    <hq-menu-item label='Tactiques' icon='fa fa-bullseye' routerLink="/tactiques">
    </hq-menu-item>
    <hq-menu-item label='Exécutions' icon='appicons ic-calendar-alt' routerLink="/executions">
    </hq-menu-item>
</hq-side-bar>